import { CreditCardFormTranslations } from '../types';
import { CreditCardPCIFields } from '../../../types';

/**
 * Creates fields config
 * @param {Array} requiredFields - collection of required fields
 * @returns Fields configuration
 */
const createFieldsConfig = (
  requiredFields: string[],
  translations: CreditCardFormTranslations,
  fieldsStyles: Record<string, any>
) => {
  const config: Record<
    CreditCardPCIFields,
    {
      selector: string;
      required: boolean;
      placeholder?: string;
      next_focus?: string;
      style?: Record<string, any>;
    }
  > = {
    [CreditCardPCIFields.Number]: {
      selector: '#number',
      required: requiredFields.includes(CreditCardPCIFields.Number),
      placeholder: translations.creditCardNumber.placeholder,
      next_focus: 'month',
    },
    [CreditCardPCIFields.SecurityCode]: {
      selector: '#cvv',
      required: requiredFields.includes(CreditCardPCIFields.Number),
      placeholder: translations.securityCode.placeholder,
    },
    [CreditCardPCIFields.ExpirationYear]: {
      selector: '#year',
      required: requiredFields.includes(CreditCardPCIFields.Number),
      style: fieldsStyles[CreditCardPCIFields.ExpirationYear],
      next_focus: 'cvv',
    },
    [CreditCardPCIFields.ExpirationMonth]: {
      selector: '#month',
      required: requiredFields.includes(CreditCardPCIFields.Number),
      style: fieldsStyles[CreditCardPCIFields.ExpirationMonth],
      next_focus: 'year',
    },
  };

  return config;
};

export default createFieldsConfig;
